// extracted by mini-css-extract-plugin
module.exports = {"radio":"selectNavi_radio__3zmF5"};